import React, { createContext, useContext } from "react";
import { Box } from "@mui/material";
import { ErrorOutlineOutlined as ErrorOutlineOutlinedIcon } from "components/icon/mui_icon";
import { StyledToolTip } from "customStyled";

// Error messages of the field around this icon (set by FormControlUI)
export const FieldErrorContext = createContext([]);

/**
 * The red error icon of a field. Hovering it (or focusing it with the
 * keyboard) shows the field's error message; the message is not shown under
 * the field any more.
 */
const FieldErrorIcon = ({ messages = null }) => {
  const fieldMessages = useContext(FieldErrorContext);
  const list = messages ?? fieldMessages;
  const icon = <ErrorOutlineOutlinedIcon sx={{ fontSize: "1rem" }} color="error" />;
  if (!list?.length) return icon;
  const text = list.map((m) => `*${m}`).join("\n");
  return (
    <StyledToolTip
      title={<Box component="span" sx={{ whiteSpace: "pre-line" }}>{text}</Box>}
      placement="top"
      arrow
    >
      <Box
        component="span"
        tabIndex={0}
        role="img"
        aria-label={text}
        data-testid="field-error-icon"
        sx={{ display: "inline-flex", cursor: "help", outline: "none" }}
      >
        {icon}
      </Box>
    </StyledToolTip>
  );
};

export default FieldErrorIcon;
